import { airlineById } from '@am/sim';
import { useState } from 'react';
import { airlineSymbolUrl } from '../art';

export { LOGO_URL, passengerFaceUrl } from '../art';

/**
 * An airline's white symbol, for a badge in its colour (the code, if it has no symbol or the
 * picture does not load).
 */
export function AirlineSymbol({ airline, size }: { airline: number; size: number }) {
  const [broken, setBroken] = useState(false);
  const a = airlineById(airline);
  const url = airlineSymbolUrl(airline, true);
  if (!url || broken) return <>{a?.code ?? '??'}</>;
  return (
    <img
      className="airline-symbol"
      src={url}
      alt={a?.code ?? ''}
      width={size}
      height={size}
      draggable={false}
      onError={() => setBroken(true)}
    />
  );
}
